import { Button, Card, CardActions, DialogContent, Grid, Stack } from "@mui/material";
import { useCallback, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import { TModalContent, defaultValuesForm } from "..";
import axiosClient from "../../../../../../lib/axios";
import CardPrincipal from "./CardPrincipal";
import CardProdutos, { IDataProdutoNF } from "./CardProdutos";
import DialogConfirmRecebimento from "./DialogConfirmRecebimento";
import DialogFullScreen from "../../../../../../components/DialogFullScreen";
import { useNavigate } from "react-router-dom";

export default function FormRecebimentoMercadorias({
    handleClose,
    onCleanForm
}: FormRecebimentoMercadoriasProps) {

    const queryClient = useQueryClient();
    const navigate = useNavigate();

    //formulario
    const { getValues, reset, watch } = useFormContext()
    //

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    //queries e mutations
    const { mutate: registrarRecebimento, isLoading } = useMutation({
        mutationKey: 'registrar-recebimento-mercadoria',
        mutationFn: (inputs: any) => axiosClient.post("/estoque/entrada-mercadorias/registrar", inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onError: ({ response }) => {
            enqueueSnackbar('Erro ao registrar recebimento!', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar('Recebimento registrado com sucesso!', { variant: 'success' });
            queryClient.invalidateQueries('pesquisar-historico-mercadorias');
            navigate('/estoque/entrada-produtos/historico-entradas');
            handleClose();
        }
    })
    //

    //funções manipuladoras
    const handleSendForm = useCallback(async () => {
        const { notaFiscal, produtosNF } = getValues()

        const params = {
            nota_fiscal_id: notaFiscal.id,
            produtos: produtosNF.map((produto: IDataProdutoNF) => {
                let motivo = '';
                if (!produto.recebido) motivo = 'Não recebido';
                if (produto.status !== 'Encontrado') motivo = 'Produto não encontrado na OC';
                if (Number(produto.quantidade_recebida) !== Number(produto.nf_quantidade)) motivo = 'Quantidade recebida diferente da nota fiscal';
                return {
                    nf_item_id: produto.nf_item_id,
                    numero_ordem_compra: produto.numero_ordem_compra,
                    ordem_compra_item_id: produto.ordem_compra_item_id,
                    quantidade_recebida: produto.quantidade_recebida,
                    recebido: produto.recebido,
                    status: produto.status,
                    motivo
                }
            })
        }
        registrarRecebimento(params)
    }, [getValues, registrarRecebimento])

    //

    return (
        <>
            <DialogFullScreen open={true} handleClose={handleClose} title="Registrar recebimento de mercadorias">
                <DialogContent sx={{ mt: 2, bgcolor: "#f0f0f0" }} >
                    {/* <Container maxWidth="xl"> */}
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12}}>
                            <CardPrincipal />
                        </Grid>
                        <Grid size={{xs: 12}}>
                            <Card>
                                <CardProdutos />
                                <CardActions>
                                    <Stack width={'100%'} direction="row" spacing={2} justifyContent={'flex-end'} alignItems="center">
                                        <Button
                                            variant="text"
                                            onClick={() => {
                                                reset({ ...defaultValuesForm })
                                                onCleanForm()
                                            }}
                                        >
                                            Limpar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                setOpenConfirmDialog(true)
                                            }}
                                            disabled={isLoading || watch("produtosNF").length === 0}
                                        >
                                            Receber
                                        </Button>
                                    </Stack>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid size={{xs: 12}}>

                        </Grid>
                    </Grid>
                    {/* </Container> */}
                </DialogContent>
            </DialogFullScreen>

            {
                openConfirmDialog &&
                <DialogConfirmRecebimento
                    open={openConfirmDialog}
                    isLoading={isLoading}
                    onClose={() => setOpenConfirmDialog(false)}
                    onConfirm={handleSendForm}
                    recebimentos={getValues("produtosNF")}
                />
            }
        </>
    )
}

interface FormRecebimentoMercadoriasProps {
    modalContent: TModalContent,
    onBack: () => void,
    handleClose: () => void,
    onCleanForm: () => void
}